// extracted by mini-css-extract-plugin
export default {"w":"ConnactUs_w__5Qg+L","name":"ConnactUs_name__u6EE7"};